<template>
  <BaseFormField
    :label="label"
    :hide-label="hideLabel"
    :hide-form-group="hideFormGroup"
  >
    <div
      :class="classForInput"
    >
      <input
        v-model="valueMin"
        class="form-control"
        :placeholder="placeholderMin"
        :required="requireMin"
        :min="min"
        :max="valueMax"
        @change="onChange"
      >
    </div>
    <div
      :class="classForInput"
    >
      <input
        v-model="valueMax"
        class="form-control"
        :placeholder="placeholderMax"
        :required="requireMax"
        :min="valueMin"
        :max="max"
        @change="onChange"
      >
    </div>
  </BaseFormField>
</template>

<script>
import messages from './locales';
import sharedMessages from '@/core/locales';
import BaseFormField from './BaseFormField';

export default {
  name: 'InputMinMax',
  components: {BaseFormField},
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: Object,
      default() {
        return { min: null, max: null };
      }
    },
    label: {
      type: String,
      default() { return this.$i18n.t('INPUT_MIN_MAX.LABEL'); } 
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hideFormGroup: {
      type: Boolean,
      default: false
    },
    placeholderMin: {
      type: String,
      default() { return this.$i18n.t('INPUT_MIN_MAX.PLACEHOLDER_MIN'); }
    },
    placeholderMax: {
      type: String,
      default() { return this.$i18n.t('INPUT_MIN_MAX.PLACEHOLDER_MAX'); }
    },
    requireMin: {
      type: Boolean,
      default: true
    },
    requireMax: {
      type: Boolean,
      default: true
    },
    min: {
      type: Number,
      default: null,
      // validator (value) {
      //   return this.max === null || value < this.max;
      // }
    },
    max: {
      type: Number,
      default: null,
      // validator (value) {
      //   return this.min === null || value > this.min;
      // }
    },
    classForInput: {
      type: String,
      default: 'col-md-1'
    }
  },
  data() {
    return {
      valueMin: this.value.min,
      valueMax: this.value.max
    };
  },
  methods: {
    onChange() {
      let valid = false;

      if((!this.requireMin || this.requireMin && this.valueMin !== null)
        && (this.min === null || this.min !== null && this.valueMin >= this.min)) {
        valid = true;
      }

      if((!this.requireMax ||this.requireMax && this.valueMax !== null)
        && (this.max === null || this.max !== null && this.valueMax <= this.max)) {
        valid = valid && true;
      } else {
        valid = false; 
      }

      if (this.valueMin !== null && this.valueMax !== null && this.valueMin < this.valueMax) {
        valid = valid && true;
      } else {
        valid = false; 
      }

      this.$emit('change', {valid, min: this.valueMin, max: this.valueMax});
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss" scoped>
</style>